import { COMMA, ENTER, SEMICOLON } from '@angular/cdk/keycodes';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatChipEditedEvent } from '@angular/material/chips';
import { DTypeFormChipListField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'chiplist-field-component',
    templateUrl: './chiplist-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeChiplistFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormChipListField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    displayedValue: string;

    readonly separators = [COMMA, ENTER, SEMICOLON];

    constructor() { }

    ngOnInit() {
        this.displayedValue = (this.field.control.value ?? []).join(', ');

        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

    paste(event: ClipboardEvent): void {
        event.preventDefault();
        event.clipboardData
            .getData('Text')
            .split(/;|,|\n/)
            .forEach(value => {
                if (value.trim()) {
                    this.addChip(value.trim());
                }
            })
    }

    addChip(v: string) {
        if ((v || '').trim()) {
            const value = this.field.control.value ?? [];
            value.push(v.trim());
            this.field.control.setValue(value);
            this.displayedValue = this.field.control.value.join(', ');
        }
    }

    removeChip(i: number) {
        const value = this.field.control.value ?? [];
        value.splice(i, 1);
        this.field.control.setValue(value);
        this.displayedValue = this.field.control.value.join(', ');
    }

    editChip(i: number, event: MatChipEditedEvent) {
        const value = event.value.trim();
        const list = this.field.control.value ?? [];

        // Remove chip if it no longer has a value
        if (!value) {
            this.removeChip(i);
            return;
        }

        // Edit existing chip
        if (i > -1) {
            list[i] = value;
            this.field.control.setValue(list);
            this.displayedValue = this.field.control.value.join(', ');
        }
    }

}
